import { type ComponentWorkflowsRequest, type PageRelation } from './page-layout.model';

const LAYOUT_INPUT_PREFIX = 'Layout#';

export function warnOnUnwiredRelations(
  relations: PageRelation[] | undefined,
  componentWorkflows: ComponentWorkflowsRequest | undefined,
): void {
  for (const { sourceId, targetId } of relations ?? []) {
    const targetWorkflow = componentWorkflows?.[targetId]?.workflow;

    if (!targetWorkflow) {
      console.warn(
        `Relation from '${sourceId}' to '${targetId}' is declared, but '${targetId}' has no ` +
          `workflow — the relation is not wired.`,
      );
      continue;
    }

    const layoutInputPrefix = `${LAYOUT_INPUT_PREFIX}${sourceId}#`;
    const hasMatchingLayoutInput = Object.keys(targetWorkflow.inputs ?? {}).some((key) =>
      key.startsWith(layoutInputPrefix),
    );

    if (!hasMatchingLayoutInput) {
      console.warn(
        `Relation from '${sourceId}' to '${targetId}' is declared, but '${targetId}''s workflow ` +
          `has no '${layoutInputPrefix}…' input — the relation is not wired.`,
      );
    }
  }
}
